import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchGlobalSearchResults, fetchRecentItemsService } from './globalSearch.service'

const initialState = {
    searchFetchStatus: 'idle',
    searchFetchError: null,
    latestQuery: '',
    sections: [],
    recentItems: [],
    recentFetchStatus: 'idle',
}

export const fetchGlobalSearch = createAsyncThunk(
    'globalSearch/fetch',
    async (payload = {}, { rejectWithValue }) => {
        try {
            const response = await fetchGlobalSearchResults(payload)
            return response
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message)
        }
    }
)

export const fetchRecentItems = createAsyncThunk(
    'globalSearch/fetchRecents',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchRecentItemsService()
            return response
        } catch (error) {
            return rejectWithValue(error?.response?.data || error?.message)
        }
    }
)

const globalSearchSlice = createSlice({
    name: 'globalSearchSlice',
    initialState,
    reducers: {
        clearGlobalSearch: (state) => {
            state.searchFetchStatus = 'idle'
            state.searchFetchError = null
            state.sections = []
            state.latestQuery = ''
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGlobalSearch.pending, (state, action) => {
                state.searchFetchStatus = 'loading'
                state.searchFetchError = null
                state.latestQuery = action.meta.arg?.search || ''
            })
            .addCase(fetchGlobalSearch.fulfilled, (state, action) => {
                const queryFromAction = action.meta.arg?.search || ''
                if (queryFromAction !== state.latestQuery) {
                    return
                }

                const payloadData = action.payload?.data || {}
                const sections = Array.isArray(payloadData?.data)
                    ? payloadData.data
                    : []
                state.searchFetchStatus = 'loaded'
                state.sections = sections.map((section, index) => ({
                    key: `${section?.title || 'section'}-${index}`,
                    title: section?.title || 'Results',
                    total: section?.total || 0,
                    count: section?.count || 0,
                    isNext: Boolean(section?.isNext),
                    limit: section?.limit || 0,
                    skip: section?.skip || 0,
                    items: Array.isArray(section?.data) ? section.data : [],
                }))
            })
            .addCase(fetchGlobalSearch.rejected, (state, action) => {
                state.searchFetchStatus = 'error'
                state.searchFetchError =
                    action.payload || 'Failed to fetch global search results'
                state.sections = []
            })
            .addCase(fetchRecentItems.pending, (state) => {
                state.recentFetchStatus = 'loading'
            })
            .addCase(fetchRecentItems.fulfilled, (state, action) => {
                const payloadData = action.payload?.data || {}
                const items = Array.isArray(payloadData?.data)
                    ? payloadData.data
                    : []
                state.recentFetchStatus = 'loaded'
                state.recentItems = items
            })
            .addCase(fetchRecentItems.rejected, (state) => {
                state.recentFetchStatus = 'error'
                state.recentItems = []
            })
    },
})

export const globalSearchState = (s) => s.globalSearchSlice || initialState
export const { clearGlobalSearch } = globalSearchSlice.actions
export default globalSearchSlice.reducer

